<template>
  <div class="promotional-banner" v-on="$listeners">
    <div class="banner-content">
      <img
        v-if="imgPath"
        :src="require(`@/assets/images/${imgPath}`)"
        :alt="title"
        class="image"
      />

      <div class="flex-1">
        <p v-if="title" class="title">
          {{ title }}
        </p>

        <p v-if="subtitle" class="subtitle">
          {{ subtitle }}
        </p>

        <Button
          v-if="buttonLabel"
          class="xs choose-button"
          :class="buttonClass"
          v-on="$listeners"
          @click="onClick"
        >
          {{ buttonText }}
        </Button>
      </div>
    </div>
    <!-- .banner-content -->

    <div v-if="$slots.hidden && showHiddenContent" class="hidden-content">
      <slot name="hidden" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionalBanner",

  props: {
    buttonClass: {
      type: String,
      default: "secondary",
    },
    buttonLabel: {
      type: String,
      default: "",
    },
    buttonLabelSlotActive: {
      type: String,
      default: "",
    },
    imgPath: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showHiddenContent: false,
    };
  },
  computed: {
    buttonText() {
      if (!this.$slots.hidden) this.buttonLabel;

      return this.showHiddenContent
        ? this.buttonLabelSlotActive
        : this.buttonLabel;
    },
  },
  methods: {
    onClick() {
      if (this.$slots.hidden) this.showHiddenContent = !this.showHiddenContent;
    },
  },
};
</script>

<style scoped>
.promotional-banner {
  @apply bg-grey-lightest p-4 border border-grey-lighter border-solid p-3 rounded-lg shadow;
  background-color: #fafafa;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.09'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

  &:hover {
    cursor: pointer;
  }
}

.banner-content {
  @apply flex items-center;
}

.image {
  @apply hidden mr-4 mb-0 rounded overflow-hidden shadow;
  object-fit: contain;
  transform: rotate(-2deg);

  width: 89px;

  @screen sm {
    @apply block;
  }
}

.title {
  @apply text-support text-sm font-black font-lato mb-0;
}

.subtitle {
  @apply text-grey-darker text-xs mb-2;
}

.hidden-content {
  @apply bg-brand-light p-4 rounded-lg mt-4 border border-grey-lighter;

  >>> p {
    @apply mb-3 text-xs text-support;

    &:last-child {
      @apply mb-0;
    }
  }
}
</style>
